///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.registrations = abcsetup.thoughtspot.registrations || {};
abcsetup.thoughtspot.registrations.show = abcsetup.thoughtspot.registrations.show || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.registrations.show = {
    // Vars
    attendee_div: null,
    sponsorshipAgreementSignatureCanvas: null,
    sponsorshipAgreementSignaturePad: null,
    sponsorshipAgreementSignatureContext: null,
    workflowId: null,
    statusId: null,
    canAutoUpdateComplexEntities: false,

    init: function () {
        // Dont block the UI/submit buttons when performing ajax
        abcsetup.performAjaxSilently = true;
        abcsetup.setTitle('ThoughtSpot Registration');

        abcsetup.thoughtspot.registrations.show.workflowId = $('#workflow_id').val();
        abcsetup.thoughtspot.registrations.show.statusId = $('#thoughtspot_registration_status_id').val();

        let status = $('#thoughtspot_registration_status_id').val();

        //If status In Progress or Submitted or Rejected, we can auto update booths & sponsorships
        //sorry for the magic numbers
        if (status == 1 || status == 2 || status == 3) {
            abcsetup.thoughtspot.registrations.show.canAutoUpdateComplexEntities = true;
        }

        // Nav-link click
        $(document).on('click', '.nav-link, .navbar-brand', function () {
            $('.nav-link.active, .navbar-brand.active').not($(this)).removeClass('active');
        });

        // Available booth link clicked
        $(document).on('click', '.booth-link', function () {
            if (!$(this).hasClass('disabled')) {
                $(this).fadeOut();
                abcsetup.thoughtspot.registrations.show.addBooth(JSON.parse($(this).find('#json').val()));

                // Calculate the booth and total costs
                abcsetup.thoughtspot.registrations.show.calculateCosts();

                // Get the booth contracts
                abcsetup.thoughtspot.registrations.show.getContracts();
            }
        });

        // Available sponsorship link clicked
        $(document).on('click', '.sponsorship-link', function () {
            if (!$(this).hasClass('disabled')) {
                let _this = $(this);

                abcsetup.thoughtspot.registrations.show.addSponsorship(JSON.parse($(this).find('#json').val()), _this);

                // Calculate the booth and total costs
                abcsetup.thoughtspot.registrations.show.calculateCosts();
            }
        });

        // Quantity changed
        $(document).on('change keyup', 'input.quantity', function () {
            // Calculate the booth and total costs
            abcsetup.thoughtspot.registrations.show.calculateCosts();

            if ($(this).val() > 1) {
                abcsetup.alerts.show(
                    'Booth Warning',
                    'Are you sure you want to select more than one of the same booth size? If so, you may continue with your submission and you will be contacted by AB to confirm.'
                );
            }
        });

        // Reserved booth delete link clicked
        $(document).on('click', '#reserved_booths .btn-remove-booth', function () {
            $(this).closest('.list-group-item').fadeOut(function () {
                // Add the booth to the available list
                $('#available_booths .list-group-item[data-id="' + $(this).find('input.booth_id').val() + '"]').show();
                $(this).remove();

                // No booths have been selected
                const reservedBooths = $('#reserved_booths');
                if (reservedBooths.find('.list-group-item').length === 0) {
                    reservedBooths.find('.alert').show();
                    reservedBooths.find('.section_validate').val('');
                }

                // Calculate the booth and total costs
                abcsetup.thoughtspot.registrations.show.calculateCosts();
                abcsetup.thoughtspot.registrations.show.updateMaxAttendeesMessage();
                abcsetup.thoughtspot.registrations.show.updateSupplierInputs();
                abcsetup.thoughtspot.registrations.show.getContracts();
            });
        });

        // Remove sponsorship link clicked
        $(document).on('click', '#reserved_sponsorships .btn-remove-sponsorship', function () {
            $(this).closest('.list-group-item').fadeOut(function () {
                // Add the sponsorship to the available list
                $('#available_sponsorships .list-group-item[data-id="' + $(this).find('input.sponsorship_id').val() + '"]').show();

                // Update the sponsorship select list
                var sponsorshipJSON = $('#available_sponsorships .list-group-item[data-id="' + $(this).find('input.sponsorship_id').val() + '"]').find('#json').val();
                sponsorshipJSON = JSON.parse(sponsorshipJSON);
                $("#sponsorships option[value='" + sponsorshipJSON.type + "']").prop("selected", false);
                $('#sponsorships').trigger('change');

                $(this).remove();

                // No sponsorships have been selected
                if ($('#reserved_sponsorships').find('.list-group-item').length == 0) {
                    $('#reserved_sponsorships').find('.alert').show();
                    $('#reserved_sponsorships .section_validate').val('');
                }

                abcsetup.blockUI(true);
                abcsetup.thoughtspot.registrations.show.sendAutoSave({
                    thoughtspot_sponsorship_id: $(this).find('input.sponsorship_id').val(),
                    remove_sponsorship: true
                });

                $('.sponsorship-request-removal-' + $(this).find('input.sponsorship_id').val()).fadeOut()

                // Calculate the booth and total costs
                abcsetup.thoughtspot.registrations.show.calculateCosts();
            });
        });

        // A broker was added - create another input field
        $(document).on('change', '.brokers input:visible', function () {
            abcsetup.thoughtspot.registrations.show.updateSupplierInputs();
        });

        // Add attendee button was clicked
        $(document).on('click', '.btn-attendee', function () {
            abcsetup.thoughtspot.registrations.show.editAttendee(null);
        });

        // Add attendee button was clicked
        $(document).on('click', '#thoughtspot-attendee-modal .btn-primary', function () {
            if ($('#thoughtspot-attendee-modal form')[0].checkValidity()) {
                abcsetup.thoughtspot.registrations.show.addAttendee();
            }
        });

        // Edit attendee button was clicked
        $(document).on('click', '.attendee_data .btn-edit', function () {
            abcsetup.thoughtspot.registrations.show.editAttendee($(this).closest('div.attendee'));
        });

        // Remove required class from files that exist
        $('input[data-type]').each(function () {
            if ($(this).val()) {
                $('.btn-upload[data-type=' + $(this).data('type') + ']').removeClass('btn-danger').addClass('btn-primary');
            }
        });

        // Cancel button clicked
        $(document).on('click', '#cancel_registration_button', function (e) {
            //const cancellation_fee = Number($('#cancel_fee').val()).toFixed(2);
            const _this = $(this);

            if (typeof _this.data('confirmed') === 'undefined') {
                abcsetup.alerts.confirm('Cancel your registration?',
                    "Are you sure you want to cancel your exhibit registration? If you cancel, you will no longer have access to your registration invitation. A cancellation fee may apply. Please refer to the terms and conditions of your contract and deadlines and fees that may apply. If you have any questions, reach out to the ThoughtSpot Planning team at thoughtspotexhibitors@cencora.com",
                    function (resp) {
                    if (resp) {
                        _this.data('confirmed', 'yes').trigger('click');
                    }
                });
                e.preventDefault();
                return false;
            }
        });


        $(document).on('click', '.btn-remove-attachment', function () {
            axios.delete(`/api/thoughtspot/registrations/remove_upload/${$(this).data('thoughtspot_registration_id')}`, {
                data: {attachment_id: $(this).data('attachment_id')},
            }).then(() => {
                $(this).closest('.attachment_file_display').remove();

                const input = $('input.attachment_file[data-type=' + $(this).data('attachment_type') + ']');
                const btn = $('.btn-upload[data-type=' + $(this).data('attachment_type') + ']');
                input.val('');

                if (btn.data('btn_danger')) {
                    btn.addClass('btn-danger').removeClass('btn-primary');
                }
            });
        });

        // Sponsorship agreement signature pad.
        $(document).on('click', '#sponsorship-agreement-clear-signature', () => {
            this.sponsorshipAgreementSignaturePad.clear();
            $('#sponsorship_agreement_signature').val('');
            $('.signature-pad-alert').addClass('d-none');
            $('button[name="form_action"].btn-success').attr('disabled', false);
        });

        this.sponsorshipAgreementSignatureCanvas = document.getElementById('sponsorship-agreement-signature-pad');
        this.sponsorshipAgreementSignatureContext = this.sponsorshipAgreementSignatureCanvas.getContext('2d');
        this.sponsorshipAgreementSignaturePad = new SignaturePad.default(this.sponsorshipAgreementSignatureCanvas);

        $(document).on('form_wizard:tab_switched', 'form.form-wizard .bs-vertical-wizard', () => this.resizeSponsorshipAgreementSignatureCanvas());
        $(window).on('resize', () => this.resizeSponsorshipAgreementSignatureCanvas());
        this.resizeSponsorshipAgreementSignatureCanvas();

        $(this.sponsorshipAgreementSignatureCanvas).on('mouseup', () => {
            $('#sponsorship_agreement_signature').val(
                this.sponsorshipAgreementSignaturePad.isEmpty() ? '' : this.sponsorshipAgreementSignaturePad.toDataURL('image/png')
            );

            let valid = abcsetup.validateSignaturePad('sponsorship-agreement-signature-pad', 'Please enter a valid signature.');

            if (valid) {
                $('button[name="form_action"]').attr('disabled', false);
            } else {
                $('button[name="form_action"]').attr('disabled', true);
            }
        });

        // submit button clicked.
        $(document).on('click', 'button[name="form_action"].btn-success', function () {
            if ($(this).attr('id') != 'booth_change_form') {
                let valid = abcsetup.validateSignaturePad('sponsorship-agreement-signature-pad', 'Please enter a valid signature.');

                if ($('#sponsorship_agreement_signature').is('[required]') && !valid) {
                    abcsetup.alerts.show('Registration Error', 'Please sign your name in the sponsorship agreement signature pad on the attachments tab.');
                    return false;
                }
            }
        });

        $(document).on('click', '#update-signature-box', function(e) {
            abcsetup.thoughtspot.registrations.show.resizeSponsorshipAgreementSignatureCanvas();

            if ($('.signatureDiv').hasClass('hide')) {
                $('.signatureDiv').removeClass('hide');
                $('#sponsorship-agreement-clear-signature').removeClass('hide');
                $(this).text("Close Signature Pad");
                abcsetup.thoughtspot.registrations.show.resizeSponsorshipAgreementSignatureCanvas();
            } else {
                $('.signatureDiv').addClass('hide');
                $('#sponsorship-agreement-clear-signature').addClass('hide');
                $(this).text("Update Signature");
                abcsetup.thoughtspot.registrations.show.resizeSponsorshipAgreementSignatureCanvas();
            }
        });

        $(document).on('change keyup', '.booth_update_quantity', function(e) {
            if ($(this).val() > $(this).data('original-register-count')) {
                $(this).parent().parent().children().find('.btn-danger').attr('disabled', true);
            } else {
                $(this).parent().parent().children().find('.btn-danger').attr('disabled', false);
            }
        })

        // Calculate the booth and total costs
        this.calculateCosts();

        // Show/hide booth contracts based on added booths
        this.getContracts();

        // Get the most up to date booth and sponsorship reservation info
        this.getAvailable();

        this.buildAutoSave();

        this.handleBoothChangeRadioButtons();

        setTimeout(function () {
            $('#messages-container .alert').fadeOut('slow');
        }, 5000);
    },

    /**
     * Add a booth to the registered booth list and handle auto saving that registration
     * uses a hidden textarea filled with booth json data. i do not know why someone would do that.
     */
    addBooth: async function (boothJSON) {
        const template = $('#template').clone();
        template.removeAttr('id');
        template.data('unsaved', true);
        template.data('max_attendees', boothJSON.max_attendees);
        template.data('max_suppliers', boothJSON.max_suppliers);
        template.data('cost', boothJSON.cost);
        template.data('id', boothJSON.id);

        template.find('#name').html(boothJSON.name);
        template.find('.additional_information').html('Max Attendees: ' + boothJSON.max_attendees + ' per space.');
        template.find('input.booth_id').val(boothJSON.id);
        template.find('input.booth_id').attr('name', 'reservations[' + boothJSON.id + ']');

        template.find('input.quantity').val(1);
        template.find('input.quantity').attr('name', 'reservations[' + boothJSON.id + '][quantity]');
        template.find('input.quantity').attr('max', boothJSON.amount_remaining > 0 ? boothJSON.amount_remaining : 0);
        template.find('input.quantity').attr('data-booth-id', boothJSON.id);

        if (abcsetup.thoughtspot.registrations.show.workflowId != null) {
            template.find('input.quantity').removeAttr('readonly');
            template.find('.remove-btn-box').removeClass('hide');
        }

        const reservedBooths = $('#reserved_booths');
        reservedBooths.find('.alert').hide();
        reservedBooths.append(template);
        reservedBooths.find('.section_validate').val(1);

        // Remove the booth from the available list
        $('#available_booths .list-group-item[data-id="' + boothJSON.id + '"]').hide();

        abcsetup.thoughtspot.registrations.show.updateMaxAttendeesMessage();
        abcsetup.thoughtspot.registrations.show.updateSupplierInputs();

        if (abcsetup.thoughtspot.registrations.show.canAutoUpdateComplexEntities) {
            abcsetup.blockUI(true);
            let response = await abcsetup.thoughtspot.registrations.show.sendAutoSave({
                add_booth: true,
                booth_id: boothJSON.id,
                quantity: 1
            });

            if (response && response.booth) {
                template.find('.btn-remove-booth').attr('data-booth-id', response.booth);
            }
        }
    },

    /**
     *
     * @param {*} sponsorshipJSON
     */
    addSponsorship: async function (sponsorshipJSON, sponsorship) {
        abcsetup.alerts.confirm('Add Sponsorship', "Are you sure you want to register for this sponsorship?", function(resp) {
            if (resp) {
                sponsorship.fadeOut();
                const template = $('#sponsorship_template').clone(true);
                template.removeAttr('id');
                template.data('unsaved', true);
                template.data('cost', sponsorshipJSON.cost);
                template.data('id', sponsorshipJSON.id);

                template.find(':input').each(function () {
                    const name = this.name || $(this).data('name') || '';
                    if (name.includes('_NEW_ITEM_')) {
                        this.name = name.replace('_NEW_ITEM_', sponsorshipJSON.id);
                        $(this).data('name', this.name);
                    }

                    $(this).attr('data-thoughtspot-sponsorship-id', sponsorshipJSON.id);
                });

                ['showIf', 'requiredIf'].forEach(attr => {
                    template.find(`[${attr}]`).each(function () {
                        $(this).attr(attr, $(this).attr(attr).replace(/_SPONSORSHIP_ID_/g, sponsorshipJSON.id));
                    });
                });

                template.find('.sponsorship_type_text').html(sponsorshipJSON.type);
                const sponsorshipType = template.find('.sponsorship_type');
                sponsorshipType
                    .attr('id', sponsorshipType.attr('id').replace('_SPONSORSHIP_ID_', sponsorshipJSON.id))
                    .val(sponsorshipJSON.rule_name);
                template.find('.additional_information').html(sponsorshipJSON.additional_information);
                template.find('input.sponsorship_id').val(sponsorshipJSON.id);

                $("#sponsorships option[value='" + sponsorshipJSON.type + "']").prop("selected", true);
                $('#sponsorships').trigger('change');

                $('#reserved_sponsorships').find('.alert').hide();
                $('#reserved_sponsorships').append(template);
                $('#reserved_sponsorships .section_validate').val(1);

                // Remove the sponsorship from the available list
                $('#available_sponsorships .list-group-item[data-id="' + sponsorshipJSON.id + '"]').hide();

                template.find('.btn-remove-sponsorship').attr('data-sponsorship-id', sponsorshipJSON.id);
                template.find('.btn-remove-sponsorship').removeClass('hide');
            }

            abcsetup.blockUI(true);
            let response = abcsetup.thoughtspot.registrations.show.sendAutoSave({
                add_sponsorship: true,
                thoughtspot_sponsorship_id: sponsorshipJSON.id,
            });

            if (response && response.sponsorship) {
                let sponsorship = response.sponsorship;
                template.find('.btn-remove-sponsorship').attr('data-sponsorship-id', sponsorship.thoughtspot_sponsorship_id);

                //append row to sponsorship change request modal
                $('#sponsorship_table_body').append(
                    '<tr class="sponsorship-request-removal-'+sponsorship.thoughtspot_sponsorship_id+'">\
                        <td>'+ sponsorshipJSON.type +'</td>\
                        <td>'+ sponsorshipJSON.category +'</td>\
                        <td>'+ sponsorshipJSON.cost +'</td>\
                        <td>'+ sponsorshipJSON.amount_remaining +'</td>\
                        <td>'+ sponsorship.status.status_name +'</td>\
                        <td> \
                            <button type="submit" class="btn btn-danger" name="form_action" value="removal"> \
                                Request Removal \
                            </button> \
                        </td> \
                    </tr>'
                )

            }
        });
    },

    /**
     * Add an attendee to the UI & auto save their attendee data.
     */
    addAttendee: async function () {
        let id;
        let div = abcsetup.thoughtspot.registrations.show.attendee_div;
        let data = { attendee_fields: {}, add_attendee: true };

        if (div) {
            id = div.attr('id');
            data.attendee_id = id;
        } else {
            const attendeeData = $('.attendee_data');
            div = $('#attendee_template').clone();

            div.removeAttr('id').data('id', id).removeClass('hide');
            attendeeData.append(div);
            attendeeData.find('.section_validate').val(1);
            abcsetup.thoughtspot.registrations.show.updateMaxAttendeesMessage();
            abcsetup.thoughtspot.registrations.show.calculateCosts();
        }

        // Set the field values
        const modal = $('#thoughtspot-attendee-modal');
        modal.find('input, textarea, select').each(function () {
            div.find('input.' + $(this).attr('name')).val($(this).val());
            data.attendee_fields[$(this).attr('name')] = $(this).val();
        });

        abcsetup.blockUI(true);
        let response = await abcsetup.thoughtspot.registrations.show.sendAutoSave(data);

        if (response && response.attendee) {
            modal.find('input, textarea, select').each(function () {
                div.find('input.' + $(this).attr('name')).attr('name', 'attendees[' + response.attendee + '][' + $(this).attr('name') + ']');
            });

            // Update the attendee display
            div.find('.name').text(modal.find('#onsite_contact_first_name').val() + ' ' + modal.find('#onsite_contact_last_name').val());
            div.find('.company').text(modal.find('#onsite_contact_company').val() + ' ' + modal.find('#onsite_contact_job_title').val());
            div.find('.remove-attendee-btn').attr('data-id', response.attendee);
            div.find('.btn-edit').attr('data-id', response.attendee);
            div.attr('id', response.attendee);

            abcsetup.thoughtspot.registrations.show.attendee_div = null;

            modal.modal('hide');
        } else {
            console.error('Error: Missing response data or attendee information.');
        }
    },

    /**
     * Render the edit attendee modal for updating.
     */
    editAttendee: function (attendeeDiv) {
        $('#thoughtspot-attendee-modal').find('input, textarea, select').val('');
        abcsetup.thoughtspot.registrations.show.attendee_div = attendeeDiv;

        // Pre-populate the model
        if (attendeeDiv !== null) {
            attendeeDiv.find('input').each(function () {
                $('#thoughtspot-attendee-modal').find('[name=' + $(this).attr('class') + ']').val($(this).val());
            });

            $('#thoughtspot-attendee-modal .btn-primary').html('Update Attendee');

        } else {
            $('#thoughtspot-attendee-modal .btn-primary').html('Add Attendee');
        }

        $('#thoughtspot-attendee-modal').modal('show');
    },

    /**
     * Calculate the booth, attendee up-charge, & sponsorship costs.
     */
    calculateCosts: function () {
        var totalCost = 0;

        $('#reserved_booths .list-group-item:not(#template)').each(function () {
            var cost = parseFloat($(this).data('cost')) * parseFloat($(this).find('input.quantity').val());
            totalCost = totalCost + cost;
            $(this).find('#cost').html('$' + abcsetup.addCommas(cost.toFixed(2)));
        });

        $('#reserved_sponsorships .list-group-item:not(#sponsorship_template)').each(function () {
            var cost = parseFloat($(this).data('cost')) * 1;
            totalCost = totalCost + cost;
            $(this).find('#cost').html('$' + abcsetup.addCommas(cost.toFixed(2)));
        });

        const maxAttendees = $('#reserved_booths > .list-group-item')
            .toArray()
            .reduce((sum, booth) => sum + Number($(booth).data('max_attendees') || 0), 0);

        const numBooths = maxAttendees * ($('#reserved_booths .list-group-item:not(#template)').find('input.quantity').val());

        if ($('.attendee_data .attendee').length > numBooths) {
            totalCost = totalCost + ($('.attendee_data .attendee').length - maxAttendees) * 1000;
        }

        $('#total_cost').html('Total Price: $' + abcsetup.addCommas(totalCost.toFixed(2)));
    },

    /**
     * Show/hide booth contracts based on added booths
     */
    getContracts: function () {
        $('.download_booth_contract').attr('hidden', true);
        $('#no_booth_contract_message').attr('hidden', false);
        $('#booth_contract_message').attr('hidden', true);
        $('#reserved_booths .list-group-item:not(#template)').each(function () {
            var boothId = ($(this).data('id'));
            var contractId = $('#download_booth_contract').data('id');

            $('.download_booth_contract[data-id = "' + boothId + '"]').attr('hidden', false);
            $('#booth_contract_message').attr('hidden', false);
            $('#no_booth_contract_message').attr('hidden', true);
        });
    },

    /**
     * Get the most up to date booth and sponsorship reservation info
     */
    getAvailable: function () {
        if ($('#available_booths').length === 0) {
            return false;
        }

        console.log("Loading availability...");
        axios.get(window.location.href).then(response => {
            const booths = response.data.booths;
            const heldSponsorships = response.data.held_sponsorships;
            const sponsorships = response.data.sponsorships;
            console.log('Found ' + booths.length + ' booths, ' + sponsorships.length + ' sponsorships');

            // Loop through available booths
            if (booths.length) {
                $(booths).each(function () {
                    var boothLink = $('#available_booths .list-group-item[data-id="' + this.id + '"]');
                    var availableClass = '';
                    var availablePerc = ((this.amount_remaining > 0 ? this.amount_remaining : 0) / this.total_quantity) * 100;

                    // Booths available is less than 25%
                    if (availablePerc <= 25) {
                        availableClass = 'text-warning';
                    }

                    // Booths available is less than 10%
                    if (availablePerc <= 10) {
                        availableClass = 'text-danger';
                    }

                    // No booths remaining
                    if (this.amount_remaining <= 0) {
                        boothLink.addClass('disabled');
                    } else {
                        boothLink.removeClass('disabled');
                    }

                    boothLink.find('#json').val(JSON.stringify(this));
                    boothLink.find('#available').html('<span class="' + availableClass + '">Booths remaining: <b>' + abcsetup.addCommas((this.amount_remaining > 0 ? this.amount_remaining : 0)) + '</b></span>');

                    // Existing reserved booth
                    $('#reserved_booths .list-group-item[data-id="' + this.id + '"]').find('input.quantity').attr('max', (this.amount_remaining > 0 ? this.amount_remaining : 0));
                });
            }

            // Loop through available sponsorships
            if (sponsorships.length) {
                $(sponsorships).each(function () {
                    var sponsorshipLink = $('#available_sponsorships .list-group-item[data-id="' + this.id + '"]');
                    var availableClass = '';
                    var availablePerc = ((this.amount_remaining > 0 ? this.amount_remaining : 0) / this.total_quantity) * 100;

                    // Sponsorships available is less than 25%
                    if (availablePerc <= 25) {
                        availableClass = 'text-warning';
                    }

                    // Sponsorships available is less than 10%
                    if (availablePerc <= 10) {
                        availableClass = 'text-danger';
                    }

                    // No sponsorships remaining
                    if (this.amount_remaining <= 0) {
                        sponsorshipLink.addClass('disabled');
                    } else {
                        sponsorshipLink.removeClass('disabled');
                    }

                    sponsorshipLink.find('#json').val(JSON.stringify(this));
                    sponsorshipLink.find('#available').html('<span class="' + availableClass + '">Remaining: <b>' + abcsetup.addCommas(this.amount_remaining > 0 ? this.amount_remaining : 0) + '</b></span>');
                });
            }

            if (Array.isArray(heldSponsorships)) {
                const heldSponsorshipIds = heldSponsorships.map(sponsorship => Number(sponsorship.id));
                $('#reserved_sponsorships .list-group-item:has(.sponsorship_id)').each(function () {
                    if ($(this).data('unsaved') || $(this).attr('id') === 'sponsorship_template') {
                        return;
                    }

                    if (!heldSponsorshipIds.includes(Number($(this).find('.sponsorship_id').val()))) {
                        abcsetup.alerts.show(
                            'Sponsorship Hold Expired',
                            `Your hold on sponsorship "${$(this).find('.sponsorship_type_text').text().trim()}" has expired. You will need to add it again to start a new hold.`,
                            () => $(this).find('.btn-remove').trigger('click')
                        );
                    }
                });
            }

            setTimeout(function () {
                abcsetup.thoughtspot.registrations.show.getAvailable();
            }, 5000);
        });
    },

    /**
     * _jquery.fieldLib
     *      Fields have been init - this is the event
     */
    fieldsInit: function () {
        abcsetup.thoughtspot.registrations.show.updateMaxAttendeesMessage();
        abcsetup.thoughtspot.registrations.show.updateSupplierInputs();
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the event
     */
    uploadDone: function () {
        const template = $('#attachment_template').clone(true);
        const Attachment = abcsetup.uploader.uploadResult.Attachment;
        const btn = $('.btn-upload[data-type=' + Attachment.type + ']');
        const input = $('input.attachment_file[data-type=' + Attachment.type + ']');
        const lang = input.val() ? 'replaced' : 'uploaded and saved';

        btn.removeClass('btn-danger').addClass('btn-primary');
        $('.manual_attachments .errorMsg').remove();

        input.val(Attachment.id);
        $('#sell_sheet_attachment').trigger('change');

        $('.item_attachments .attachment_file_display.' + Attachment.type).remove();

        template.addClass(Attachment.type).removeClass('hide');
        template.find('.attachment_type_name').text(Attachment.type_name)
        template.find('.btn-remove-attachment')
            .attr('title', 'Delete ' + Attachment.type_name)
            .attr('data-attachment_id', Attachment.id)
            .attr('data-attachment_type', Attachment.type);
        template.find('.attachment_open_link')
            .attr('href', `/thoughtspot/registrations/download/${Attachment.upload_uuid}`)
            .text(Attachment.name);

        $('.item_attachments').append(template);

        if (Attachment.type === 'thoughtspot_registration_insurance_doc') {
            //if ($('#thoughtspot_registration_status_id').val() == 3) {
            abcsetup.alerts.show('Update Complete', 'You\'ve successfully ' + lang + ' the insurance documentation');
            //abcsetup.alerts.show('Update Complete', 'You\'ve successfully ' + lang + ' the ' + abcsetup.uploader.uploadResult.Attachment.type_name);
            //}
        }
    },

    /**
     * Determine if we should show the exceeding max attendees message.
     */
    updateMaxAttendeesMessage() {
        const maxAttendees = $('#reserved_booths > .list-group-item')
            .toArray()
            .reduce((sum, booth) => sum + Number($(booth).data('max_attendees') || 0), 0);

        const numBooths = maxAttendees * ($('#reserved_booths .list-group-item:not(#template)').find('input.quantity').val());

        if (($('.attendee_data .attendee').length) > numBooths) {
            $('#max_attendees_message').toggle();
        } else if (maxAttendees == numBooths) {
            $('#max_attendees_message').hide(); //if user adds above max attendees & then deletes one, moving the count back to the max, hide the msg
        }
    },

    /**
     * Determine how many blank suppliers inputs we need to show depending on the selected booths' max suppliers settings.
     */
    updateSupplierInputs: function () {
        const suppliersStep = $('.brokers div.wrapper');
        const getSupplierInputs = () => suppliersStep.find('input[type=text]:not(.section_validate)');
        const countSuppliers = () => suppliersStep.find('input[type=text]:not(.section_validate)')
            .toArray()
            .reduce((sum, input) => sum + (input.value ? 1 : 0), 0);
        const maxSuppliers = $('#reserved_booths > .list-group-item')
            .toArray()
            .reduce((sum, booth) => sum + Number($(booth).data('max_suppliers') || 0), 0);

        var supplierFieldCount =  maxSuppliers * ($('#reserved_booths .list-group-item:not(#template)').find('input.quantity').val());

        if (suppliersStep.find('.suppliers-list').length > 0) {
            return;
        }

        if (countSuppliers() < supplierFieldCount) {
            // Add a blank input if we need one.

            const haveBlankInput = getSupplierInputs().toArray().some(input => !input.value);

            if (!haveBlankInput) {
                // Add a new blank input to allow for adding more suppliers.
                suppliersStep.append('<div class="new supplier"><input type="text" name="brokers[]" class="form-control mb-2" data-autocomplete="brokers" data-autocomplete-value="" value="" placeholder="Start to type your suppliers name and we will search for companies with those letters for you to choose from"></div>');

                // Apply auto complete functionality
                abcsetup.fieldLib.autoComplete($('.brokers div.new'));
                $('.brokers div.new').removeClass('new');
            }
        }

        // Make sure we don't have too many supplier inputs (this can happen when clearing out a supplier input or removing a booth selection).

        const blankInputs = getSupplierInputs().filter(function () {
            return !this.value;
        });

        if (countSuppliers() < supplierFieldCount) {
            // We're below the limit, remove all but one blank input to allow the user to add another supplier.

            blankInputs.slice(1).remove();
        } else {
            // We're at or above the limit, remove all blank inputs and then any filled in inputs, if necessary.

            blankInputs.remove();

            if (countSuppliers() > supplierFieldCount) { // After removing the blanks, we still have too many suppliers.
                abcsetup.alerts.show('Some Suppliers Removed', `Some of the selected suppliers were to be removed. The booth selections allow for ${supplierFieldCount} suppliers.`);

                getSupplierInputs()
                    .filter(function () {
                        return Boolean(this.value);
                    })
                    .slice(supplierFieldCount)
                    .each(function () {
                        const supplierId = String($(this).data('autocompleteValue') || '')
                            .replace(/^(\d+)\|.*$/, '$1')
                            .trim();

                        // Remove the auto-complete field and its hidden counterpart.
                        $(this).remove();
                        if (supplierId) {
                            $(`input[value=${supplierId}]`).remove();
                        }
                    });
            }
        }

        suppliersStep.find('.section_validate').val(countSuppliers() > 0 ? 1 : '');
    },

    // Adjust canvas coordinate space taking into account pixel ratio to make it look crisp on mobile devices
    // This also causes canvas to be cleared
    resizeSponsorshipAgreementSignatureCanvas: function () {
        let canvas = this.sponsorshipAgreementSignatureCanvas;

        //if the canvas is not visible return
        if (!$(canvas).is(':visible')) {
            return;
        }

        //if the canvas has a signature return
        const context = canvas.getContext('2d');
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height).data;

        for (let i = 0; i < imageData.length; i += 4) {
            // Check if any non-transparent pixel is present
            if (imageData[i + 3] !== 0) {
                return;
            }
        }

        // When zoomed out to less than 100% some browsers report devicePixelRatio as < 1 and only part of the canvas is cleared
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
    },

    /**
     * build json payloads for auto saving supplier entered data
     */
    buildAutoSave: async function() {
        $('.x-auto-save').each(function(e) {
            $(this).on('change', function(e) {
                if (!$(this).hasClass('invalid')) {
                    abcsetup.thoughtspot.registrations.show.sendAutoSave({
                        field_name: $(this).data('real-name'),
                        value: $(this).val()
                    });
                }
            })
        });

        $('.x-auto-save-sponsorship-fields').each(function(e) {
            $(this).on('change', function(e) {
                if (!$(this).hasClass('invalid')) {
                    let thoughtspot_sponsorship_id = $(this).data('thoughtspot-sponsorship-id');
                    if (thoughtspot_sponsorship_id != null && thoughtspot_sponsorship_id != '') {
                        abcsetup.thoughtspot.registrations.show.sendAutoSave({
                            thoughtspot_sponsorship_id: thoughtspot_sponsorship_id,
                            field_name: $(this).data('real-name'),
                            value: $(this).val()
                        });
                    }
                }
            });
        });

        //auto save removing a booth
        $(document).on('click', '.btn-remove-booth', function(e) {
            if (abcsetup.thoughtspot.registrations.show.canAutoUpdateComplexEntities) {
                abcsetup.blockUI(true);
                abcsetup.thoughtspot.registrations.show.sendAutoSave({
                    booth_id: $(this).data('booth-id'),
                    remove_booth: true
                });
            }
        });

        $(document).on('click', '.btn-remove-sponsorship', function(e) {
            if (abcsetup.thoughtspot.registrations.show.canAutoUpdateComplexEntities) {
                abcsetup.blockUI(true);
                abcsetup.thoughtspot.registrations.show.sendAutoSave({
                    thoughtspot_sponsorship_id: $(this).data('sponsorship-id'),
                    remove_sponsorship: true
                });
            }
        })

        //auto save removing an attendee
        $(document).on('click', '.remove-attendee-btn', function(e) {
            let _this = $(this);

            abcsetup.alerts.confirm("Remove attendee?",  "Are you sure you want to delete this attendee?", function(resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    abcsetup.thoughtspot.registrations.show.sendAutoSave({
                        remove_attendee: true,
                        attendee_id: _this.data('id')
                    });

                    //im so sorry for this
                    _this.parent().parent().parent().parent().fadeOut(function () {
                        $(this).remove();
                        if ($('.attendee_data .attendee').length === 0) {
                            $('.attendee_data .section_validate').val('');
                        }

                        abcsetup.thoughtspot.registrations.show.updateMaxAttendeesMessage();
                        abcsetup.thoughtspot.registrations.show.calculateCosts();
                    });
                }
            })
        });
    },

    /**
     * Send the auto save payload and resolve the promise
     */
    sendAutoSave: function(data) {
        return new Promise((resolve, reject) => {
            let registrationId = $('#thoughtspot_registration_id').val();
            data.registrationId = registrationId;

            axios.post('/thoughtspot/registrations/' + registrationId + '/autosave', data)
                .then(response => {
                    abcsetup.unblockUI();
                    resolve(response.data); // Resolve the promise with the response data
                })
                .catch(error => {
                    abcsetup.unblockUI();
                    console.error(error);
                    reject(error); // Reject the promise in case of an error
                });
        });
    },

    handleBoothChangeRadioButtons: function() {
        $('#booth_change_form_submit').attr('disabled', true);

        $(document).on('click', '.editable-booth-radio', function(e) {
            if ($(this).val() == 'no_action') {
                $(this).parent().parent().parent().find('.booth_update_quantity')
                    .attr('disabled', true)
                    .attr('required', false);
            }

            if ($(this).val() == 'update' || $(this).val() == 'request_removal') {
                $(this).parent().parent().parent().find('.booth_update_quantity')
                    .attr('disabled', false)
                    .attr('required', true);
            }
        });

        $(document).on('click', '.register-booth-radio', function(e) {
            if ($(this).val() == 'no_action') {
                $(this).parent().parent().parent().find('.booth_update_quantity')
                    .attr('disabled', true)
                    .attr('required', false);
            } else {
                $(this).parent().parent().parent().find('.booth_update_quantity')
                    .attr('disabled', false)
                    .attr('required', true);
            }
        });

        $(document).on('click', '.form-check-input', function(e) {
            let count = 0;

            $('.form-check-input').each(function() {
                if ($(this).is(':checked') && $(this).val() != 'no_action') {
                    count++;
                }
            });

            if (count > 0) {
                $('#booth_change_form_submit').attr('disabled', false);
            } else {
                $('#booth_change_form_submit').attr('disabled', true);
            }
        });
    },

    fieldError: function() {
        console.log($('form').find('.invalid').first().parent().html());
        abcsetup.unblockUI();
    }
}
